{
  "version": 1,
  "asset_id": "6b13c7df-5328-4912-bfda-46d09f491c9a",
  "project_id": "63ffb125-aed4-4f54-959a-0b116fa77b1d",
  "url": "/__l5e/assets-v1/6b13c7df-5328-4912-bfda-46d09f491c9a/band-tubing-1200.webp",
  "r2_key": "a/v1/63ffb125-aed4-4f54-959a-0b116fa77b1d/6b13c7df-5328-4912-bfda-46d09f491c9a/band-tubing-1200.webp",
  "original_filename": "band-tubing-1200.webp",
  "size": 37828,
  "content_type": "image/webp",
  "created_at": "2026-09-20T00:21:00Z"
}
